export const assertNotUndefined = (value, valueName = 'the value') => {
    if (value === undefined) {
        throw new Error(`${valueName} shouldn't be undefined`);
    }
};
